export const HC_ACCOUNTS_SERVICE_PATH = '/v4/';

